enum CalendarIntegrationType {
  AMPAREX = 'AMPAREX',
  ASEGO = 'ASEGO',
  BLUEPRINT = 'BLUEPRINT',
  GOOGLE = 'GOOGLE',
  MEINTERMIN = 'MEINTERMIN',
  OUTLOOK = 'OUTLOOK_INTERNAL',
  PULSAR = 'PULSAR',
  SYCLE = 'SYCLE',
  SYCLE_PRO = 'SYCLE_PRO',
  TCM = 'TCM',
}

export { CalendarIntegrationType }
